// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"a3bf8ba3","513":"97a98935","959":"b835ccde"}[chunkId] + ".chunk.js";
};